import React from 'react'
import CustomInvView from '../invoice/CustomInvView'

const CustomInvoiceView = () => {
  return (
    <CustomInvView/>
  )
}

export default CustomInvoiceView